/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useContext } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Teams,
} from '../../../utils/api';

import { ARMcontext } from '../../../utils/context/context';
import { useInputValue } from '../../../utils/hooks/useInputValue';
import {
  LabelsWrapper,
  LabelsContainer,
  TextContainer,
  AlertContainer,
  Oval,
} from '../../players/wellness/styles';
import {
  Leaderboard,
  PlayerScorecard,
  PlayerHealth,
  PlayerVelocity,
  PlayerWorkloads,
} from '../../players';

import {
  PlayerKeyMetrics,
  PlayerExams,
  PlayerAccountability,
  PlayerWellness
} from '../../players/playerPortal'

import { Routes, Route, useParams, useLocation, useNavigate } from 'react-router-dom';
import {
  PlayersDataSection,
  PlayersFilterSection,
} from '../../players/styles';
import {
  Navbar,
  FiltersContainer,
  Tabs,
  Modal,
  PlayerBanner,


} from '../../../components';
import PhonesPremium from '../../../assets/images/phonesPremiumModal.png'
import ArrowPremium from '../../../assets/images/arrowRedPremiumModal.png'
import logoDotComTeam from '../../../assets/images/logoDotComPremium.png'
import { ButtonPremiumUpgradeLogOut, LiItemsPremiumUpgrade, UlPremiumUpgrade } from '../styles';


const DefaultPlayers = [
  { title: 'Players', lenght: 50 },
  { title: 'Pitchers', lenght: 20 },
  { title: 'Catchers', lenght: 30 },
];

const PlayerPills = [
  {
    title: 'Key Metrics',
    url: 'keyMetrics',
  },
  {
    title: 'Exams',
    url: 'exams',
  },
  {
    title: 'Accountability',
    url: 'accountability',
  },

  {
    title: 'Wellness',
    url: 'wellness',
  },
];

export default () => {
  const { selectedPlayer, user, HandleSelectedPlayer, setStrengthRecovery } = useContext(ARMcontext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [defaultPlayers, useDefaultPlayers] = useState<Array<any>>(DefaultPlayers);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [players, usePlayers] = useState<any>(defaultPlayers[0]);
  const [modal, useModal] = useState<boolean>(false);
  const filterPlayer = useInputValue('', 'search');
  const navigate = useNavigate();
  const location = useLocation();
  const TEAM = new Teams()

  useEffect(() => {
    if (location.pathname === '/player-portal') navigate('/player-portal/keyMetrics', { replace: true });
  }, [location])

  useEffect(() => {
    const loadKeyMetric = async (id:string) => {
        const result = await TEAM.GetKeyMetricsPlayer(id)
        const playerData = result.data?.data?.player;
        const strengthData = result.data?.data?.strengthRecovery;
        HandleSelectedPlayer({
          ...playerData,
          _id: id
        });
        setStrengthRecovery([
          ...strengthData
        ])
    }
    if(!user.data) return () => {
      navigate('login')
    }
    loadKeyMetric(user.data._id)
  },[user.data])

  useEffect(()=>{
    if(user.secondaryRole === 'org-admin') return
    if(user?.data?.plan && user.data.plan === 'basic')
      useModal(true)
  },[user?.data?.plan])


  const {HandleSignOut} = React.useContext(ARMcontext);
   function handleOut(): void {
    HandleSignOut();
    navigate('/login');
  }
 return (
    <>

     <div className={`app-container ${modal ? 'blur-background' : ''}`} style={{ filter: modal ? 'blur(10px)' : 'none' }}>

      <ToastContainer />
      <Navbar />
      <FiltersContainer cy-data="players_filters">
        {selectedPlayer?.name ? (
          <>
            <PlayerBanner selectedPlayer={selectedPlayer} />
          </>
        ) : (
          <div>loading</div>)}
      </FiltersContainer>

      <PlayersDataSection>
        <FiltersContainer bColor="var(--BackgroundGrey)">
          <PlayersFilterSection>
            <Tabs dataArray={selectedPlayer?.name ? PlayerPills : []} url={'/player-portal'} />
            {window.location.href.includes('player-portal/wellness') && (
              <LabelsWrapper>
                <TextContainer>WELLNESS ALERT</TextContainer>
                <LabelsContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'yellow'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'red'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'blue'} />
                    <span> Medical</span>
                  </AlertContainer>
                </LabelsContainer>
              </LabelsWrapper>
            )}
          </PlayersFilterSection>
        </FiltersContainer>
        <Routes>
          <Route path={`:playersId/*`} element={selectedPlayer?.name && (
              <SelectedPlayerRouter filterPlayer={filterPlayer.value} playersGroup={players.value} />
            )}>
          </Route>
        </Routes>
      </PlayersDataSection>
      </div>

      {modal && (
         <Modal margin="6vh auto 200px auto" minWidth='60rem' padding='4rem 0' >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: 'auto' }}>
          <img src={logoDotComTeam} alt="Logo ArmCare" />
          <p style={{fontSize: '34px', width: '390px', textAlign:'center' }}>Go to your mobile app and update to premium!</p>

          <div style={{display:'flex', flexDirection: 'row'}}>
            <section style={{position: 'relative', }}>
              <img width={424} src={PhonesPremium} style={{position:'relative', zIndex: 99}} alt="Phones Premium Example" />
              <img src={ArrowPremium} style={{position: 'absolute', top:'38px', left: '395px'}} alt="Arrow Red" />
            </section>
            <section style={{display: 'flex', flexDirection:'column', justifyContent: 'space-around', WebkitAlignItems: 'flex-start', marginTop: '36px', marginLeft: '24px'}}>
              <div style={{fontSize: '24px', fontWeight: 700, lineHeight: '26px', letterSpacing: '-2%', color: 'red', zIndex: 99, marginTop: '27px'}}>
                <span style={{color: 'white'}}>UPGRADE</span> <span style={{marginLeft: '42px'}}>TO PREMIUM</span>
              </div>
              <UlPremiumUpgrade>
                <LiItemsPremiumUpgrade>Access test data and track your progress</LiItemsPremiumUpgrade>
                <LiItemsPremiumUpgrade>Unlock individual muscle data</LiItemsPremiumUpgrade>
                <LiItemsPremiumUpgrade>See how your arm fatigues</LiItemsPremiumUpgrade>
                <LiItemsPremiumUpgrade>Individualized throwing recommendations</LiItemsPremiumUpgrade>
                <LiItemsPremiumUpgrade>Share PDF reports with scouts & coaches</LiItemsPremiumUpgrade>
              </UlPremiumUpgrade>
              <ButtonPremiumUpgradeLogOut onClick={handleOut}>
                Log Out
              </ButtonPremiumUpgradeLogOut>
            </section>
          </div>
        </div>
    </Modal>
      )}
    </>
  );
};

const SelectedPlayerRouter = ({ playersGroup, filterPlayer }) => {
  const { playersId } = useParams() as any;
  return (
    <>

      {playersId === 'exams' ? (
        <PlayerExams />
      ) : playersId === 'keyMetrics' ? (
        <PlayerKeyMetrics />
      ) : playersId === 'health' ? (
        <PlayerHealth />
      ) : playersId === 'scorecard' ? (
        <PlayerScorecard />
      ) : playersId === 'velocityTest' ? (
        <PlayerVelocity />
      ) : playersId === 'playerWorkloads' ? (
        <PlayerWorkloads />
      ) : playersId === 'accountability' ? (
        <PlayerAccountability playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : playersId === 'wellness' ? (
         <PlayerWellness />
      ) : playersId === 'leaderboard' ? (
        <Leaderboard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : (
        <></>
      )}

    </>
  );
};
